// @ts-nocheck

import * as SpineAnimationAssets from '../../../assets/spine/animations';
import { SpineAnimationIds } from '../../../types/animations';

export const BoomSpineAnimations = {
  // HALLOWEEN
  [SpineAnimationIds.BOOM_HALLOWEEN_EXPLOSION]: [
    {
      assets: SpineAnimationAssets.HalloweenExplosionAnimation,
      forwards: true,
    },
  ],
  // VALENTINE
  [SpineAnimationIds.BOOM_VALENTINE_START_DE]: [
    {
      assets: SpineAnimationAssets.ValentineStartDEAnimation,
      forwards: true,
    },
  ],
  [SpineAnimationIds.BOOM_VALENTINE_START_EN]: [
    {
      assets: SpineAnimationAssets.ValentineStartENAnimation,
      forwards: true,
    },
  ],
  [SpineAnimationIds.BOOM_VALENTINE_START_ES]: [
    {
      assets: SpineAnimationAssets.ValentineStartESAnimation,
      forwards: true,
    },
  ],
  [SpineAnimationIds.BOOM_VALENTINE_START_FR]: [
    {
      assets: SpineAnimationAssets.ValentineStartFRAnimation,
      forwards: true,
    },
  ],
  [SpineAnimationIds.BOOM_VALENTINE_IDLE_STEP_1]: [
    {
      assets: SpineAnimationAssets.ValentineIdleAnimation,
      forwards: true,
      skin: 'step_1',
      loop: true,
    },
  ],
  [SpineAnimationIds.BOOM_VALENTINE_IDLE_STEP_2]: [
    {
      assets: SpineAnimationAssets.ValentineIdleAnimation,
      forwards: true,
      skin: 'step_2',
      loop: true,
    },
  ],
  [SpineAnimationIds.BOOM_VALENTINE_IDLE_STEP_3]: [
    {
      assets: SpineAnimationAssets.ValentineIdleAnimation,
      forwards: true,
      skin: 'step_3',
      loop: true,
    },
  ],
  [SpineAnimationIds.BOOM_VALENTINE_IDLE_STEP_4]: [
    {
      assets: SpineAnimationAssets.ValentineIdleAnimation,
      forwards: true,
      skin: 'step_4',
      loop: true,
    },
  ],
  [SpineAnimationIds.BOOM_VALENTINE_IDLE_STEP_5]: [
    {
      assets: SpineAnimationAssets.ValentineIdleAnimation,
      forwards: true,
      skin: 'step_5',
      loop: true,
    },
  ],
  [SpineAnimationIds.BOOM_VALENTINE_EXPLOSION]: [
    {
      assets: SpineAnimationAssets.ValentineExplosionAnimation,
      forwards: true,
    },
  ],
  // ST PATRICK
  [SpineAnimationIds.BOOM_PATRICK_START]: [
    {
      assets: SpineAnimationAssets.PatrickStartAnimation,
      forwards: true,
    },
  ],
  [SpineAnimationIds.BOOM_PATRICK_IDLE_STEP_1]: [
    {
      assets: SpineAnimationAssets.PatrickIdleAnimation,
      forwards: true,
      skin: '1',
      loop: true,
    },
  ],
  [SpineAnimationIds.BOOM_PATRICK_IDLE_STEP_2]: [
    {
      assets: SpineAnimationAssets.PatrickIdleAnimation,
      forwards: true,
      skin: '2',
      loop: true,
    },
  ],
  [SpineAnimationIds.BOOM_PATRICK_IDLE_STEP_3]: [
    {
      assets: SpineAnimationAssets.PatrickIdleAnimation,
      forwards: true,
      skin: '3',
      loop: true,
    },
  ],
  [SpineAnimationIds.BOOM_PATRICK_IDLE_STEP_4]: [
    {
      assets: SpineAnimationAssets.PatrickIdleAnimation,
      forwards: true,
      skin: '4',
      loop: true,
    },
  ],
  [SpineAnimationIds.BOOM_PATRICK_IDLE_STEP_5]: [
    {
      assets: SpineAnimationAssets.PatrickIdleAnimation,
      forwards: true,
      skin: '5',
      loop: true,
    },
  ],
  [SpineAnimationIds.BOOM_PATRICK_EXPLOSION]: [
    {
      assets: SpineAnimationAssets.PatrickExplosionAnimation,
      forwards: true,
    },
  ],
};
